export default __webpack_public_path__ + "static/media/pabst-dashboard-image.dd38cc57.png";